import React from 'react';
import { CheckIcon, XIcon, TruckIcon, EyeIcon, MapPinIcon, CheckCircleIcon, RotateCcwIcon, AlertTriangleIcon } from 'lucide-react';
interface OrderActionsProps {
  status: 'pending' | 'pending-collection' | 'shipped' | 'delivered' | 'returned' | 'cancelled' | 'disputing';
}
export const OrderActions = ({
  status
}: OrderActionsProps) => {
  const getActions = () => {
    switch (status) {
      case 'pending':
        return <>
            <button className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700" data-id="element-439">
              <CheckIcon className="h-3.5 w-3.5 mr-1" data-id="element-440" />
              Confirm
            </button>
            <button className="inline-flex items-center px-3 py-1.5 border border-red-600 text-xs font-medium rounded-md text-red-600 hover:bg-red-50" data-id="element-441">
              <XIcon className="h-3.5 w-3.5 mr-1" data-id="element-442" />
              Cancel
            </button>
          </>;
      case 'pending-collection':
        return <>
            <button className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700" data-id="element-443">
              <TruckIcon className="h-3.5 w-3.5 mr-1" data-id="element-444" />
              Ship
            </button>
            <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 hover:bg-gray-50" data-id="element-445">
              <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-446" />
              Details
            </button>
          </>;
      case 'shipped':
        return <>
            <button className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700" data-id="element-447">
              <MapPinIcon className="h-3.5 w-3.5 mr-1" data-id="element-448" />
              Track
            </button>
            <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 hover:bg-gray-50" data-id="element-449">
              <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-450" />
              Details
            </button>
          </>;
      case 'delivered':
        return <>
            <button className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700" data-id="element-451">
              <CheckCircleIcon className="h-3.5 w-3.5 mr-1" data-id="element-452" />
              Complete
            </button>
            <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 hover:bg-gray-50" data-id="element-453">
              <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-454" />
              Details
            </button>
          </>;
      case 'returned':
        return <>
            <button className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700" data-id="element-455">
              <RotateCcwIcon className="h-3.5 w-3.5 mr-1" data-id="element-456" />
              Process Return
            </button>
            <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 hover:bg-gray-50" data-id="element-457">
              <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-458" />
              Details
            </button>
          </>;
      case 'cancelled':
        return <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 hover:bg-gray-50" data-id="element-459">
            <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-460" />
            Details
          </button>;
      case 'disputing':
        return <>
            <button className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700" data-id="element-461">
              <AlertTriangleIcon className="h-3.5 w-3.5 mr-1" data-id="element-462" />
              Resolve
            </button>
            <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 hover:bg-gray-50" data-id="element-463">
              <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-464" />
              Details
            </button>
          </>;
      default:
        return <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 hover:bg-gray-50" data-id="element-465">
            <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-466" />
            Details
          </button>;
    }
  };
  return <div className="flex items-center space-x-2" data-id="element-467">{getActions()}</div>;
};